import {colors} from "@c10h/colors";
import {useTranslation} from "ni18n";
import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {useV5ImgSrc} from "src/useV5ImgSrc";

const Media: React.VoidFunctionComponent = () => {
  const i18n = useTranslation();

  const cards = [
    {
      url: "https://www.youtube.com/watch?v=e8qzHwTDPDs",
      pattern: useV5ImgSrc("/illustrations/pattern-7"),
      backgroundColor: colors.lighterGreen,
      icon: "oaklandas fs30",
      text: i18n.t("How Carbon Health helped get the Oakland A’s back in the game"),
      ariaLabel: i18n.t("Go to a video about COVID Ready Program Partnership with the Oakland A's"),
      alt: "Oakland A’s",
      eventClass: "event-JIWj5V",
      patternFilter: "contrast(700%)",
    },
    {
      url: "https://www.forbes.com/sites/waynerash/2020/08/27/the-safer-workplace--how-cloud-based-solutions-help-companies-cope-with-covid-10/",
      pattern: useV5ImgSrc("/illustrations/pattern-1-purple"),
      backgroundColor: colors.lightPurple,
      icon: "forbes fs40",
      text: i18n.t("The safer workplace: Cloud Based Solutions help companies cope"),
      ariaLabel: i18n.t("Go to an article from the Forbes about safer workplace."),
      alt: "Forbes",
      eventClass: "event-JIWj5B",
    },
    {
      url: "https://www.nbcnews.com/tech/covid-passports-are-coming-not-easy-build-rcna554",
      pattern: useV5ImgSrc("/illustrations/pattern-2"),
      backgroundColor: colors.lighterRed,
      icon: "nbc-news fs30 fs24-xs",
      text: i18n.t("The next vaccine challenge: Building a workable 'passport' app"),
      ariaLabel: i18n.t("Go to an article from NBC News about building vaccine passport apps."),
      alt: "NBC News",
      eventClass: "event-I8u6ni",
    },
    {
      url: "https://www.wsj.com/articles/covid-19-vaccination-cards-are-the-only-proof-of-shots-soon-an-essential-11617105602",
      pattern: useV5ImgSrc("/illustrations/pattern-1-purple"),
      backgroundColor: colors.lighterBlue,
      icon: "wsj fs46",
      text: i18n.t("Vaccination cards are the only proof of shots, soon an essential"),
      ariaLabel: i18n.t("Go to an article from the Wall St. Journal about vaccine cards."),
      alt: "Wall Street Journal",
      eventClass: "event-JIWj5L",
    },
    {
      url: "https://www.latimes.com/science/story/2021-04-09/heres-what-to-do-with-your-covid-19-vaccination-card-including-if-you-lose-it",
      pattern: useV5ImgSrc("/illustrations/pattern-2"),
      backgroundColor: colors.lightYellow,
      icon: "los-angeles-times fs32 fs28-xs",
      text: i18n.t("What to do with your vaccination card, including if you lose it"),
      ariaLabel: i18n.t("Go to an article from the Los Angeles Times about vaccine cards."),
      alt: "Los Angeles Times",
      eventClass: "event-UHLtNo",
    },
  ];

  const imgSrc = useV5ImgSrc("/illustrations/squiggles");

  return (
    <div className="ph8 pt30 pb48 bg-gray50 pos-r pv14-md">
      <div className="maxw80 ma df aic aifs-xs fdc">
        <span className="ttu font-im fs13 mb7 ls-3 mb4-md">{i18n.t("In the press")}</span>
        <h2 className="tac mb14 tal-xs fs48 fs28-xs mb8-md">
          {i18n.t("Carbon Health is making headlines")}
        </h2>
        <div className="dg gafr gtc3fr gg12 zIndex1 gtcn-md gg3-md ma-md">
          {cards.map(
            ({
              url,
              backgroundColor,
              pattern,
              icon,
              text,
              ariaLabel,
              eventClass,
              patternFilter,
              alt,
            }) => (
              <a
                key={url}
                href={url}
                target="_blank"
                className="pos-r maxw17 p6 pt26 mb6 minw0-xs w100p-xs df fdc jcfe br3 bs2 t-150 hover-scale7 hover-gray800"
                style={{backgroundColor}}
                rel="noreferrer"
                aria-label={ariaLabel}
              >
                <LazyLoadImage
                  className="pos-a right0 top0 pen"
                  src={pattern}
                  style={{filter: patternFilter}}
                  alt={alt}
                />
                <span
                  className={`pos-a-f br50 df aic jcc h10 w10 t-150 focus-bsDarkBlue3 ${eventClass}}`}
                  style={{top: 13, right: 13, backgroundColor: colors.gray800 + 20}} // HEX+
                >
                  <span className="cIcon-arrow-45deg fs14" aria-hidden />
                </span>
                <span className={`cIcon-${icon} mb6 gray800`} />
                <p className="fs20 font-cm gray800 ls-3">{text}</p>
              </a>
            ),
          )}
        </div>
      </div>
      <LazyLoadImage className="pos-a right0 bottom0" src={imgSrc} alt="" />
    </div>
  );
};

export default Media;
